import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { ClientService } from 'src/app/services/clients/client.service';
import { CbService } from 'src/app/services/contentbuilder/contentbuilder.service';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { CampaignBuilderService } from 'src/app/services/segmentation/campaign-builder.service';

@Component({
  selector: 'app-campaign-events',
  templateUrl: './campaign-events.component.html',
  styleUrls: ['./campaign-events.component.css']
})
export class CampaignEventsComponent extends BaseComponent implements OnInit {
  @ViewChild('searchText', { static: true }) searchText: ElementRef;
  totalCount: number = 0;
  eventObj: any = [];
  ord = 'asc';
  colname = "section_name";
  limit = 10;
  offset = 0;
  page = 1;

  checked = false;
  getCompanyobj;
  currentUser;
  companyID = 0;

  today: number = Date.now();
  constructor(
    private clientService: ClientService,
    private cb: CbService,
    private campaignService:CampaignBuilderService
  ) {
    super();
  }
  ngOnInit() {
    this.templateLogData()
    this.getCompany();
  }

  ngAfterViewInit() {
    this.searchText.nativeElement.value = '';
    fromEvent(this.searchText.nativeElement, 'keyup')
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => {
          this.offset = 0;
          this.page = 1;
          this.ngxSpinnerService.show();
        }),
        switchMap(data => this.campaignService.getCampaignEvents(this.companyID,
          {
            limit: this.limit,
            skip: this.offset
          },
          this.searchText.nativeElement.value

        ))
      )
      .subscribe(res => {
        if (res.status) {
          if (res.data.rows == null) { this.eventObj = [] }
          else { this.eventObj = res.data.rows }
          this.totalCount = res.data.total;
        } else {
          this.eventObj = [];
          this.totalCount = 0;
        }
        this.ngxSpinnerService.hide();
      });
  }

  onCompanyChange(company) {
    this.companyID = company;
    if(this.companyID > 0){this.getCompanyCampaign();}else{
      this.eventObj = [];
      this.totalCount = 0;
      this.page = 1;
        }
  }

  setOrder(value: string) {
    this.colname = value;
    if (this.ord == 'asc') {
      this.ord = 'desc'
    } else { this.ord = 'asc' }
    this.getCompanyCampaign();
  }

  templateLogData() {
    let themeLogs = {
      log_type: "Campaign Event Builder List",
      log_name: "Campaign Event List",
      log_description: "Campaign Event List",
      moduleid: 228,
      moduleitemid: 416,
      per_id: 14
    }
    this.logs.addNewLogs(themeLogs).subscribe(data => {

    }, error => {

    });
  }

  getCompanyCampaign() {
    this.offset = (this.page - 1) * this.limit;
    this.ngxSpinnerService.show();
    this.campaignService.getCampaignEvents(
      this.companyID,
      {
        limit: this.limit,
        skip: this.offset
      },
      this.searchText.nativeElement.value

    ).subscribe(data => {
      if (data.status) {
        if (data.data.rows == null) { this.eventObj = [] }
        else { this.eventObj = data.data.rows }
        this.totalCount = data.data.total;
        this.ngxSpinnerService.hide();
      } else {
        this.eventObj = [];
        this.totalCount = 0;
        this.ngxSpinnerService.hide();
      }
    }, error => {
      console.log(error);
      this.ngxSpinnerService.hide();
    });
  }

  editSection(id) {
    this.router.navigate(['/corporate/add-campaign-event'], { queryParams: { companyID: this.companyID, id: id } });
  }
  deleteSection(id) {
    this.confirmationDialogService.confirm('Please confirm', 'Are you sure you want to Delete ?', 'Yes', 'No')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.campaignService.daleteCampaignEventById(this.companyID, id).subscribe(data => {
            if (data.status) {
              this.getCompanyCampaign()
              setTimeout(() => {
                this.toastrService.success("Deleted Successfully");
              }, 1000)
            } else {
              this.toastrService.error(data.message);
            }
            this.ngxSpinnerService.hide();
          }, error => {
            console.log(error);
            this.ngxSpinnerService.hide();
          });
        }
      })
      .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

  updateStatus(event, id, status) {
    event.preventDefault();
    let obj = this.eventObj.find(element => {
      if (element.id === id) {
        return true;
      }
    });
    this.confirmationDialogService.confirm('Please confirm', 'Are you sure you want to change the status?', 'YES', 'NO')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.campaignService.updateStatusCampaignEvent(this.companyID,id,{is_active:!obj.is_active}).subscribe(data => {
            this.getCompanyCampaign()
            this.toastrService.success("Section Status Changed Successfully")
            this.ngxSpinnerService.hide();
          });
        } else {
        
        }


      }).catch((err) => {
        });


  }



  getCompany() {
    let self = this;
    this.clientService.getBUCompanies().subscribe(data => {
      self.getCompanyobj = data.data;
      self.hydrateWorkingCompany(self, (id) => { self.onCompanyChange(id); });

    }, error => {
    });
  }
}